import type { RiskGapModel } from '@ctw/shared/api/fhir/models/risk-gap';

export function buildRiskGapTelemetryContext(
  riskGap: RiskGapModel,
  options?: { evidenceCount?: number },
) {
  return {
    riskGapId: riskGap.id,
    riskGapType: riskGap.type,
    riskGapStatus: riskGap.status,
    riskGapConfidenceRating: riskGap.confidenceRating,
    riskGapEvidenceCount: options?.evidenceCount,
  };
}
